import T, { useTranslate } from '@/components/Helpers/Translate'
import { useGetCustomerTypesDiscounts } from '@/lib/hooks/helpers/order/useGetCustomerTypesDiscounts'
import { getFixedCurrency } from '@/lib/utils/numbers/getFixedCurrency'
import useGlobalStore from '@/store/useGlobalStore'
import { CartSavingsItem } from './CartSavingsItem'

const CartSheetSavings = () => {
  const {
    user: { customerType },
    cart: { subscribe },
  } = useGlobalStore()

  const { translate } = useTranslate()
  const { customerTypeDiscount } = useGetCustomerTypesDiscounts()

  const subscriptionDiscount = subscribe.reduce(
    (accumulator, item) => accumulator + item.subscriptionDiscount * item.qty,
    0,
  )

  if (customerType === 'Customer') return null

  return (
    <div className="rounded-xl bg-blue-100 p-5">
      <p className="text-primary">
        <T>your_savings</T>:
      </p>
      {customerTypeDiscount > 0 && (
        <CartSavingsItem
          description={`${translate(
            customerType.toLocaleLowerCase(),
          )} ${translate('discount')}`}
          amount={getFixedCurrency({ amount: customerTypeDiscount })}
        />
      )}
      {subscriptionDiscount > 0 && (
        <CartSavingsItem
          description={translate('subscription_discount')}
          amount={getFixedCurrency({ amount: subscriptionDiscount })}
        />
      )}
    </div>
  )
}

export default CartSheetSavings
